import {
  type MenuTreeNode,
  type UrlListItem,
  isGraphLocationDescriptor,
  isPageItem,
} from 'components/Sidebar/menuTree';
import type { Location } from 'history';
import deepEqual from 'react-fast-compare';

const getAllChildrenUrl = (menuTreeNodes: MenuTreeNode[]): UrlListItem[] =>
  menuTreeNodes.reduce<UrlListItem[]>((acc, menuTreeNode) => {
    if (menuTreeNode.urlList) {
      for (const url of menuTreeNode.urlList) {
        acc.push(url);
      }
    }

    if (Array.isArray(menuTreeNode.children)) {
      return acc.concat(getAllChildrenUrl(menuTreeNode.children));
    }

    return acc;
  }, []);

/**
 * In case path ends with '/', cut it and then compare pathname
 */
export const navigationIncludesCurrentPath = (
  menuTreeNode: MenuTreeNode,
  location: Location,
): boolean => {
  const { pathname, state } = location;

  const hasChildren = Array.isArray(menuTreeNode.children);
  const list = Array.isArray(menuTreeNode.children)
    ? getAllChildrenUrl(menuTreeNode.children)
    : menuTreeNode.urlList;

  if (!list) {
    return false;
  }

  const path =
    pathname[pathname.length - 1] === '/'
      ? pathname.substring(0, pathname.length - 1)
      : pathname;
  return list.some((item) => {
    if (typeof item === 'function') {
      return item(path);
    }
    if (isPageItem(item)) {
      return item.url === path;
    }

    if (isGraphLocationDescriptor(item)) {
      return (
        item.to === path &&
        // Ignore state equality for first level menu item so submenu stays open
        // if state doesn't match any of it's children, but path is included
        (hasChildren || deepEqual(item.state, state))
      );
    }
    return item === path;
  });
};
